import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Stopwatch from '../Stopwatch'
import { longCurrency } from '../../../utils/currency'
import styled from 'styled-components'
import GenericButton from '../GenericButton'
import styles from './prices.module.scss'

function Price(props) {
  const {
    basePrice,
    currentPrice,
    discountExpireAt,
    buttonAction,
    buttonText,
    around,
    currency,
  } = props
  const hasDiscount = currentPrice < basePrice
  const hasExpire = !!discountExpireAt

  return (
    <div className={styles.root}>
      {hasDiscount && <div className={styles.basePrice}>{basePrice}</div>}
      <div className={styles.currentPrice}>
        {around && `от `}
        {currentPrice}
        {longCurrency(currency, currentPrice)}
      </div>
      {hasExpire ? (
        <div className={styles.sale}>
          <DangerButton>
            <Stopwatch from="now" to={discountExpireAt} />
          </DangerButton>
          <span className={styles.saleLabel}> – до конца скидки</span>
        </div>
      ) : (
        <SubscribeButton onClick={buttonAction}>{buttonText}</SubscribeButton>
      )}
    </div>
  )
}

const DangerButton = styled(GenericButton)`
  color: #fff;
  background-color: #eb4734;
  padding: 2px 8px;
  font-size: 14px;
  min-width: 0;
  line-height: 1.54;
`

const SubscribeButton = styled(GenericButton)`
  color: #2a3133;
  border: 1px solid #ebecec;
  border-radius: 5px;
  background-color: #fff;
  padding: 2px 8px;
  font-size: 13px;
  min-width: 0;
  line-height: 1.54;
`

Price.propTypes = {
  basePrice: PropTypes.number,
  currentPrice: PropTypes.number,
  buttonAction: PropTypes.func,
  buttonText: PropTypes.string,
  around: PropTypes.bool,
  currency: PropTypes.object,
}

const mapStateToProps = (state) => ({
  currency: state.currency,
})

export default connect(mapStateToProps)(Price)
